export default "__VITE_ASSET__DCab9Tcf__"